module.exports = __webpack_public_path__ + "media/images/logos/bg-lg-f0171dc4de980d258a05d6f907a02c10.png";